import React from 'react';

import { GqlClientOptions, useGqlContext } from '@search/gql-client/src';

import { ClassifiedFilterCollection } from '../../../filters/ClassifiedFilterCollection';
import { offerFilterGqlFromRoute } from '../offerFilterGqlFromRoute';
import { offerSearchPageFilterToRoute } from '../offerSearchPageFilterToRoute';
import { SearchOffersCountQuery$data as SearchOffersCountQueryResponse, SearchOffersCountQuery$variables as SearchOffersCountQueryVariables } from './__generated__/SearchOffersCountQuery.graphql';
import { SearchOffersCountQuery } from './SearchOffersCountQuery';

export function useSearchOffersCountFetcher() {
    const gql = useGqlContext();

    return React.useCallback(
        (vars: {
            filters: ClassifiedFilterCollection;
        }, opts?: GqlClientOptions) => gql.client<
            SearchOffersCountQueryVariables,
            SearchOffersCountQueryResponse
        >(SearchOffersCountQuery, {
            ...vars,
            filters: offerFilterGqlFromRoute(offerSearchPageFilterToRoute(vars.filters))
        }, opts),
        [ gql ]
    );
}
